export default __webpack_public_path__ + "static/omar_playing-ff4a64da34c1f03e0dfc0dfb68c3a31b.png";